// extracted by mini-css-extract-plugin
export default {"wrapperComponent":"ThankYouRegister_wrapperComponent__eT3Ia","actions":"ThankYouRegister_actions__yowA-"};